const MAP_VIEW = 'map';
const LIST_VIEW = 'list';

export default class HomeController {
    /* @ngInject */
    constructor($log, $location, $interval, $timeout, $routeParams, AuthService, ThingsService,
        MapService, EventsService) {
        this.$log = $log;
        this.$location = $location;
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.$routeParams = $routeParams;
        this.AuthService = AuthService;
        this.ThingsService = ThingsService;
        this.MapService = MapService;
        this.EventsService = EventsService;
        this.view = MAP_VIEW;
        this.things = [];
        this.alarms = [];
        this.rootDomain = undefined;
        this.periodicMapRefresh = undefined;
        this.selectedDomainId = undefined;
        this.query = undefined;
        this.contextOpen = false;
        this.isLoading = true;
        this.showListView = true;
    }

    isMapView() { return this.view === MAP_VIEW; }
    isListView() { return this.view === LIST_VIEW; }
    activateMapView() {
        this.view = MAP_VIEW;
        localStorage.setItem('VIEW', MAP_VIEW);

        // Wait a cycle in order to let the view know its map-div extent
        this.$timeout(() => {
            this.MapService.showCartsOnMap(this.things, 'mapid');
        }, 0);
    }
    activateListView() {
        this.view = LIST_VIEW;
        localStorage.setItem('VIEW', LIST_VIEW);
    }

    $onInit() {
        this.view = localStorage.getItem('VIEW') === null ? MAP_VIEW : localStorage.getItem('VIEW');

        if (this.$routeParams.domain) {
            this.ThingsService.selectedDomain = this.$routeParams.domain;
        }

        this.getThings();
        this.getDomains();

        // Refresh map every 3 minutes
        this.periodicMapRefresh = this.$interval(() => {
            this.getThings();
        }, 3 * 60000);

        if (this.AuthService.isTransportChief()) {
            this.showListView = false;
        }
    }

    $onDestroy() {
        this.MapService.destroy();
        this.$interval.cancel(this.periodicMapRefresh);
        this.periodicMapRefresh = undefined;
    }

    getThings() {
        this.ThingsService.getThings()
            .then((response) => {
                this.things = response.hits.hits;

                const params = {
                    fromDate: (new Date()).setMonth(-12),
                    toDate: (new Date()).valueOf(),
                };
                this.EventsService.getEventsToAcknowledge(params)
                    .then((events) => {
                        this.alarms = events.hits.hits;

                        this.alarms.forEach((a) => {
                            this.things.forEach((t) => {
                                if (a._source.source.thingName === t._source.thingName) {
                                    t.hasAlarms = true;
                                }
                            });
                        });

                        // To prevent problem with map-extent -> Only init map when map-view is visible
                        if (this.view === MAP_VIEW) {
                            this.MapService.showCartsOnMap(this.things, 'mapid');
                        }
                    })
                    .catch((error) => {
                        this.$log.info(`Error getting events: ${error}`);
                    });
            })
            .catch((error) => {
                this.$log.info(`Error getting things: ${error}`);
                this.$location.path('/login');
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    getDomains() {
        this.ThingsService.getDomains()
            .then((rootDomain) => {
                this.rootDomain = rootDomain;
            })
            .catch((error) => {
                this.$log.info(`Error getting domains: ${error}`);
            });
    }

    filterOnDomain(domainId) {
        this.ThingsService.selectedDomain = domainId;
        this.getThings();
    }

    isEmpty() {
        return this.things && this.things.length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home-view/home-view.controller.js